import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ element: Component, ...rest }) => {
  const user = localStorage.getItem("accessToken");
  const location = useLocation();

  console.log("Current location pathname:", location.pathname);
  // Check if route starts with /dashboard
  const isDashboardRoute = location.pathname.startsWith("/dashboard") || location.pathname.startsWith("/onboarding");
  console.log("isDashboardRoute:", isDashboardRoute);

  if (!user) {
    return (
      <Navigate
        to={isDashboardRoute ? "/vendor-login" : "/login"}
        replace
      />
    );
  }

  return <Component {...rest} />;
};

export default ProtectedRoute;
